import { i18n } from '/vodalys/vvuejs/vue.js'

import { flattenTranslations } from './flattenTranslations'
import messages from '../../**/vlang/*.js'


export const flattenLocales = flattenTranslations(messages)

for (let [locale, messages] of Object.entries(flattenLocales)) {
    i18n.mergeLocaleMessage(locale, messages)
}


// Hot Module Replacement for i18n
if (module.hot) {
    module.hot.accept();
}